<template>
	<div class="page">
		<el-row>
		  <el-col :xs="0" :sm="20" :md="20" :lg="20" :xl="20" :offset="2">
			  <div class="grid-content image">
				  <div class="imagelist" v-for="item in array" :key="item.Id">
					  <a :href="item.url">
					  <el-image
					    style="width: 100%; height: auto;"
					    :src="domain + item.image"></el-image>
						</a>
				  </div>
			</div>
		  </el-col>
		<!-- 手机端 -->
		  <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
		  			  <div class="grid-content mobile-image">
		  				  <div class="mobile-imagelist" v-for="item in array" :key="item.Id">
							  <a :href="item.url">
		  					  <el-image
		  					    style="width: 100%; height: auto;"
		  					    :src="domain + item.image"></el-image>
								</a>
		  				  </div>
		  			</div>
		  </el-col>
		</el-row>

		
	</div>
</template>

<script>
	export default{
		name:'member',
		metaInfo() {
		  return {
			title: '会员频道 - ' + this.metaName,
			meta: [
			  { charset: "utf-8" },
			  { name: "keywords", content: this.metaKeywords },
			  { name: "description", content: this.metaDecs },
			],
		  };
		},
		data(){
			return{
				metaName: "",
				metaKeywords: "",
				metaDecs: "",
				domain:this.$utils.httpUrl,
				array:[]
				
			}
		},
		mounted() {
			this.getMembers()
			this.$axios({
				url:this.$utils.httpApi + 'index/webconfig'
			}).then(res=>{
				this.metaName = res.data.data.webtitle
				this.metaDecs = res.data.data.webdescription
				this.metaKeywords = res.data.data.webkeywords
			})
		},
		created() {
			this.getMembers()
		},
		methods:{
			getMembers(){
				this.$axios({
					url:this.$utils.httpApi + 'details/getMembers'
				}).then(res=>{
					this.array = res.data.data
				})
			}
		}
	}
</script>

<style scoped>
	.el-col {
		border-radius: 4px;
	}
	.bg-purple-dark {
		background: #99a9bf;
	}
	.bg-purple {
		background: #d3dce6;
	}
	.bg-purple-light {
		background: #e5e9f2;
	}
	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}
	.image{
		display:flex;
		flex-wrap: wrap;
		justify-content: flex-start;
	}
	.imagelist{
		width:13%;
		padding:0 0.6% 10px 0.6%;
	}
	.mobile-image{
		display:flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		margin-bottom: 20px;
	}
	.mobile-imagelist{
		width:46%;	
		padding:0 1.8% 10px 1.8%;
	}

</style>